import React, { Component } from 'react'
import Card from '../components/Card'
import Image from '../components/Image'
import Paragraph from '../components/Paragraph'
import Row from '../components/Row'

export default class UseStep extends Component {
  render() {
    const { image, str } = this.props

    return (
      <Card>
        <Card.Pad>
          <Row alignCenter>
            <Row.Cell style={{ marginRight: '2rem' }}>
              <Image src={image} />
            </Row.Cell>
            <Row.Cell>
              <Paragraph str={str} />
            </Row.Cell>
          </Row>
        </Card.Pad>
      </Card>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/UseStep.js